import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FormulaCheckDialogData {
    isValid: boolean;
    explanation: string;
    currentFormula: string;
    correctedFormula?: string | null;
    suggestions?: string[];
    context?: string;
    tokenUsage?: {
        promptTokens: number;
        responseTokens: number;
        totalTokens: number;
        userAccountUpdated: boolean;
    };
}

@Component({
    selector: 'app-formula-check-dialog',
    templateUrl: './formula-check-dialog.component.html',
    styleUrls: ['./formula-check-dialog.component.scss']
})
export class FormulaCheckDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<FormulaCheckDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FormulaCheckDialogData
    ) { }

    onApplyCorrection(): void {
        this.dialogRef.close({ action: 'apply', correctedFormula: this.data.correctedFormula });
    }

    onKeepOriginal(): void {
        this.dialogRef.close({ action: 'keep' });
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    get hasCorrection(): boolean {
        return !this.data.isValid &&
            this.data.correctedFormula &&
            this.data.correctedFormula.trim() !== '';
    }

    get hasSuggestions(): boolean {
        return this.data.suggestions && this.data.suggestions.length > 0;
    }

    get hasTokenUsage(): boolean {
        return this.data.tokenUsage && this.data.tokenUsage.totalTokens > 0;
    }
} 